import { takeLatest } from "redux-saga/effects";
import createRequestSaga from "../../../common/saga/createRequestSaga";
import * as bookMultiRequestApi from "../api/bookMultiRequestApi";
import { PURCHASE_REQUEST_BATCH } from "../actionCreators";

const purchaseRequestBatch = createRequestSaga(
  PURCHASE_REQUEST_BATCH,
  bookMultiRequestApi.purchaseRequestBatchApi
);

export function* bookMultiRequestSaga() {
  yield takeLatest(PURCHASE_REQUEST_BATCH, purchaseRequestBatch);
}
